import React, { useState, useEffect } from 'react';

export default function PaymentModalTPV({ montoTotal, pedido, onClose, onPaymentSuccess, tipoVenta, permiteDescuento = true, permiteDividir = false, comensales = 1, metodosPersonalizados = [] }) {
    const [metodo, setMetodo] = useState('EFECTIVO');
    // 🚩 "Otros": métodos de pago que el negocio agrega desde Ajustes (ej: un
    // sistema de tarjetas externo). Se guarda el nombre exacto como metodo_pago
    // (no "OTROS" genérico), así el reporte de caja los agrupa cada uno aparte.
    const [mostrarOtros, setMostrarOtros] = useState(false);
    const esMetodoPersonalizado = metodosPersonalizados.some(m => m.nombre === metodo);
    const [montoRecibido, setMontoRecibido] = useState(montoTotal);
    const [procesando, setProcesando] = useState(false);
    const [observacion, setObservacion] = useState('');
    const [mostrarCampoNota, setMostrarCampoNota] = useState(pedido.observacion ? true : false);
    const [tipoDesc, setTipoDesc] = useState('porcentaje'); // 'porcentaje' o 'monto'
    const [valorDesc, setValorDesc] = useState(0);
    const [dividirCuenta, setDividirCuenta] = useState(comensales > 1);
    const [numComensales, setNumComensales] = useState(comensales > 1 ? comensales : 2);

    const esDelivery = tipoVenta && tipoVenta.includes('DELIVERY');
    const yaElegidoAnteriormente = pedido && pedido.lugar_consumo;

    const [lugarConsumo, setLugarConsumo] = useState(() => {
        if (esDelivery) return 'LLEVAR';
        if (yaElegidoAnteriormente) return pedido.lugar_consumo;
        return 'LLEVAR';
    });

    const fmt = (val) => Number(val).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
   
    const billetes = [1000, 2000, 5000, 10000, 20000];
    const ahorro = tipoDesc === 'porcentaje' ? Math.round(montoTotal * (Number(valorDesc) / 100)) : Number(valorDesc);
    const totalFinal = Math.max(0, montoTotal - ahorro); 
    const cambio = metodo === 'EFECTIVO' ? Math.max(0, montoRecibido - totalFinal) : 0;

    useEffect(() => {
        setMontoRecibido(Number(totalFinal));
    }, [totalFinal, metodo]);

    const handlePago = async () => {
        setProcesando(true);
        /*const datosFinalesParaAPI = {
            cartItems: pedido.cartItems || [],
            total: montoTotal,
            metodo_pago: metodo,
            monto_pagado: metodo === 'EFECTIVO' ? montoRecibido : montoTotal,
            monto_cambio: cambio,
            observacion: observacion,
            lugar_consumo: lugarConsumo,
        };*/
        const datosFinalesParaAPI = {
            ...pedido, 
            // 🔥 LA CLAVE: Al subtotal le quitamos la propina y el envío para que sea SOLO COMIDA
            subtotal: montoTotal - (Number(pedido.propina) || 0) - (Number(pedido.costo_envio) || 0),
            
            monto_descuento: ahorro, 
            descuento_porcentaje: tipoDesc === 'porcentaje' ? (Number(valorDesc) || 0) : 0,
            total: totalFinal,       
            metodo_pago: metodo,
            monto_pagado: metodo === 'EFECTIVO' ? montoRecibido : totalFinal,
            monto_cambio: cambio,
            dividido_entre: permiteDividir && dividirCuenta ? Number(numComensales) || 1 : 1,
            dividir_cuenta: permiteDividir && dividirCuenta ? 1 : 0,
            observacion: observacion,
            lugar_consumo: lugarConsumo,
        };
        try {
            await onPaymentSuccess(datosFinalesParaAPI);
        } catch (error) { setProcesando(false); }
    };



    return (
        /* FONDO OSCURO (Igual que tu modal de Selector de Entrega) */
        <div
            className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center"
            style={{ zIndex: 99999, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(5px)' }}
        >
            <style>{`
                .tile-pago { 
                    padding: 12px; border: 2px solid #f1f3f5; border-radius: 12px; text-align: center; cursor: pointer;
                    display: flex; flex-direction: column; align-items: center; font-weight: 800; color: #adb5bd; font-size: 0.75rem;
                    transition: all 0.2s;
                }
                .tile-pago.active { border-color: #0d6efd; background: #e7f1ff; color: #0d6efd; }
                .btn-billete { border: 1px solid #dee2e6; background: white; padding: 10px 5px; border-radius: 8px; font-weight: bold; font-size: 0.8rem; }
                .btn-billete:active { background: #f8f9fa; transform: scale(0.95); }
            `}</style>

            {/* CONTENEDOR DEL MODAL */}
            <div
                className="bg-white shadow-lg d-flex flex-column animate__animated animate__zoomIn animate__faster"
                style={{
                    width: '95%',
                    maxWidth: '480px',
                    maxHeight: '90vh', /* Nunca será más alto que la pantalla */
                    borderRadius: '20px',
                    overflow: 'hidden'
                }}
            >
                {/* 1. HEADER (Fijo) */}
                <div className="p-3 border-bottom d-flex justify-content-between align-items-center bg-white">
                    <div>
                        <span className="text-muted small font-weight-bold uppercase" style={{ fontSize: '10px' }}>Total a Cobrar</span>
                        <h2 className="m-0 text-dark" style={{ fontWeight: 900 }}>${fmt(totalFinal)}</h2>
                    </div>
                    <button onClick={onClose} className="btn btn-light rounded-circle" style={{ width: '45px', height: '45px' }}>
                        <i className="fas fa-times fa-lg text-muted"></i>
                    </button>
                </div>

                {/* 2. BODY CON SCROLL (Si el contenido crece, aparece barra aquí) */}
                <div className="p-3 overflow-auto bg-white" style={{ flex: 1 }}>

                    {/* GRID DE MÉTODOS */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                        {[{ id: 'EFECTIVO', icon: 'fa-money-bill-wave', label: 'EFECTIVO' },
                        { id: 'DEBITO', icon: 'fa-credit-card', label: 'DÉBITO' },
                        { id: 'CREDITO', icon: 'fa-credit-card', label: 'CRÉDITO' },
                        { id: 'TRANSFERENCIA', icon: 'fa-mobile-alt', label: 'TRANSF.' }].map(m => (
                            <div key={m.id} className={`tile-pago ${metodo === m.id ? 'active' : ''}`} onClick={() => { setMetodo(m.id); setMostrarOtros(false); }}>
                                <i className={`fas ${m.icon} mb-1 fa-lg`}></i> {m.label}
                            </div>
                        ))}
                        {metodosPersonalizados.length > 0 && (
                            <div className={`tile-pago ${mostrarOtros || esMetodoPersonalizado ? 'active' : ''}`} style={{ gridColumn: 'span 2' }} onClick={() => setMostrarOtros(v => !v)}>
                                <i className="fas fa-ellipsis-h mb-1 fa-lg"></i> {esMetodoPersonalizado ? metodo : 'OTROS'}
                            </div>
                        )}
                    </div>

                    {mostrarOtros && metodosPersonalizados.length > 0 && (
                        <div className="d-flex flex-wrap mt-2 mb-2" style={{ gap: '8px' }}>
                            {metodosPersonalizados.filter(m => m.activo).map(m => (
                                <button
                                    key={m.id}
                                    type="button"
                                    className={`btn btn-sm ${metodo === m.nombre ? 'btn-primary' : 'btn-outline-secondary'}`}
                                    style={{ borderRadius: '20px' }}
                                    onClick={() => setMetodo(m.nombre)}
                                >
                                    {m.nombre}
                                </button>
                            ))}
                        </div>
                    )}
                    {/* SECCIÓN DESCUENTO (solo si está habilitado) */}
                    {permiteDescuento && (
                    <div className="mb-3 p-2 rounded" style={{ background: '#fff9db', border: '1px solid #fab005' }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="font-weight-bold small text-dark">DESCUENTO</span>
                            <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                                <div className="btn-group btn-group-sm">
                                    <button type="button" className={`btn btn-sm ${tipoDesc === 'porcentaje' ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setTipoDesc('porcentaje')}>%</button>
                                    <button type="button" className={`btn btn-sm ${tipoDesc === 'monto' ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setTipoDesc('monto')}>$</button>
                                </div>
                                <input
                                    type="number"
                                    className="form-control form-control-sm text-center font-weight-bold"
                                    style={{ width: '80px', border: '1px solid #fab005' }}
                                    value={valorDesc}
                                    onChange={(e) => setValorDesc(e.target.value)}
                                    onFocus={(e) => e.target.select()}
                                />
                            </div>
                        </div>
                    </div>
                    )}

                    {/* SECCIÓN DIVIDIR CUENTA */}
                    {permiteDividir && comensales >= 1 && (
                        <div className="mb-3 p-2 rounded" style={{ background: '#e3f2fd', border: '1px solid #0d6efd' }}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <span className="font-weight-bold small text-primary">
                                        <i className="fas fa-users mr-1"></i> DIVIDIR CUENTA
                                    </span>
                                    <div className="small text-muted mt-1">
                                        {dividirCuenta
                                            ? `${numComensales} comensales — $${fmt(Math.round(totalFinal / numComensales))} c/u`
                                            : 'Cobrar todo junto'}
                                    </div>
                                </div>
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="dividirSwitch"
                                        checked={dividirCuenta}
                                        onChange={(e) => setDividirCuenta(e.target.checked)}
                                    />
                                    <label className="custom-control-label" htmlFor="dividirSwitch"></label>
                                </div>
                            </div>
                            {dividirCuenta && (
                                <>
                                    <div className="d-flex align-items-center justify-content-center mt-2" style={{ gap: '10px' }}>
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            style={{ width: '32px', height: '32px', padding: 0, lineHeight: 1 }}
                                            onClick={() => setNumComensales(n => Math.max(2, n - 1))}
                                        >−</button>
                                        <span className="font-weight-bold" style={{ fontSize: '1.1rem', minWidth: '24px', textAlign: 'center' }}>
                                            {numComensales}
                                        </span>
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            style={{ width: '32px', height: '32px', padding: 0, lineHeight: 1 }}
                                            onClick={() => setNumComensales(n => n + 1)}
                                        >+</button>
                                        <small className="text-muted">comensales</small>
                                    </div>
                                    <div className="mt-2 p-2 bg-white rounded text-center" style={{ border: '1px dashed #0d6efd' }}>
                                        <small className="text-muted font-weight-bold">CADA UNO PAGA</small>
                                        <div className="h4 m-0 text-primary font-weight-bold">${fmt(Math.round(totalFinal / numComensales))}</div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {/* SECCIÓN EFECTIVO */}
                    {metodo === 'EFECTIVO' && (
                        <div className="mt-3 animate__animated animate__fadeIn">
                            {/* Input Recibido */}
                            <div className="bg-dark text-white p-3 d-flex justify-content-between align-items-center" style={{ borderRadius: '12px' }}>
                                <span className="small font-weight-bold opacity-50">RECIBIDO</span>
                                <div className="d-flex align-items-center">
                                    <span className="h4 m-0 mr-2 text-success">$</span>
                                    <input
                                        type="number"
                                        className="bg-transparent border-0 text-white text-end h3 m-0 font-weight-bold"
                                        style={{ outline: 'none', width: '130px' }}
                                        value={montoRecibido}
                                        onChange={(e) => setMontoRecibido(Number(e.target.value))}
                                        onFocus={(e) => e.target.select()}
                                        autoFocus
                                    />
                                </div>
                            </div>

                            {/* Billetes */}
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', marginTop: '10px' }}>
                               <button className="btn-billete text-primary" onClick={() => setMontoRecibido(totalFinal)}>EXACTO</button>
                                {billetes.map(b => (<button key={b} className="btn-billete" onClick={() => setMontoRecibido(b)}>${fmt(b)}</button>))}
                            </div>

                            {/* Vuelto */}
                            <div className="text-center mt-3 p-3" style={{ background: '#f8f9fa', border: '2px dashed #28a745', borderRadius: '12px' }}>
                                <small className="text-success font-weight-bold">SU VUELTO</small>
                                <div className="h2 m-0 text-success" style={{ fontWeight: 900 }}>${fmt(cambio)}</div>
                            </div>
                        </div>
                    )}

                    {/* NOTA PARA COCINA */}
                    <div className="mb-3">
                        <button
                            type="button"
                            className="btn btn-sm btn-link p-0 text-decoration-none fw-bold"
                            onClick={() => setMostrarCampoNota(!mostrarCampoNota)}
                        >
                            {mostrarCampoNota ? '- Quitar nota' : '+ Agregar nota (Sin cebolla, etc)'}
                        </button>

                        {mostrarCampoNota && (
                            <textarea
                                className="form-control mt-2"
                                rows="2"
                                placeholder="Instrucciones para cocina..."
                                value={observacion}
                                onChange={(e) => setObservacion(e.target.value)}
                                style={{ border: '2px solid #0d6efd', borderRadius: '10px' }}
                            />
                        )}
                    </div>

                    {/* LUGAR DE CONSUMO */}
                    <div className="mt-4 d-flex gap-2">
                        <button className={`btn flex-fill font-weight-bold py-2 ${lugarConsumo === 'SERVIR' ? 'btn-info text-white shadow-sm' : 'btn-light text-muted'}`} onClick={() => setLugarConsumo('SERVIR')}>SERVIR</button>
                        <button className={`btn flex-fill font-weight-bold py-2 ${lugarConsumo === 'LLEVAR' ? 'btn-warning text-white shadow-sm' : 'btn-light text-muted'}`} onClick={() => setLugarConsumo('LLEVAR')}>LLEVAR</button>
                    </div>

                </div>

                {/* 3. FOOTER (Fijo) */}
                <div className="p-3 bg-light border-top">
                    <button
                        className="btn btn-success btn-lg btn-block font-weight-bold py-3 shadow-sm"
                        style={{ borderRadius: '12px', fontSize: '1.2rem', width: '100%' }}
                        onClick={handlePago}
                        disabled={procesando || (metodo === 'EFECTIVO' && montoRecibido < totalFinal)}
                    >
                        {procesando ? 'PROCESANDO...' : `COBRAR $${fmt(totalFinal)}`}
                    </button>
                </div>

            </div>
        </div>
    );
}